import { render, staticRenderFns } from "./PersonalDocumentsEditFormSidebar.vue?vue&type=template&id=21c56236&scoped=true"
import script from "./PersonalDocumentsEditFormSidebar.vue?vue&type=script&lang=js"
export * from "./PersonalDocumentsEditFormSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c56236",
  null
  
)

export default component.exports